let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iBRMk")).then(() => parcelRequire('2mXCc'));